<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">락커</span>
            <span class="txt">
                센터에서 사용 중인 락커에대해 기본설정을 진행합니다. 락커대여 내역을 확인하고 싶으시다면,
                회원>락커대여내역 메뉴에서 확인하시면 됩니다.
            </span>
        </div>

        <div class="com-btn-area">
            <div class="right-box">
                <router-link :to="{ name: 'SettingLockerEdit' }" class="com-btn blue">락커등록</router-link>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="locker-list-content">
            <ul class="list">
                <li
                    v-for="item in data.items"
                    :key="item.p_center_prod_id + item.p_center_prod_ver"
                    @click="
                        $router.push({
                            name: 'SettingLockerEdit',
                            params: { prodNo: item.p_center_prod_id },
                            query: { page: pagingInfo.page },
                        })
                    "
                >
                    <span v-if="item.p_use_yn" class="ic">사용중</span>
                    <span v-else class="ic red">미사용</span>
                    <span class="loca">{{ item.p_namee }}</span>
                    <span class="num">
                        <span v-if="item.p_lock_sex == 'M'">남자</span>
                        <span v-else-if="item.p_lock_sex == 'W'">여자</span>
                        <span v-else>공통</span>
                        / {{ item.p_lock_no_range_start }}-{{ item.p_lock_no_range_end }}
                    </span>
                    <span v-if="item.p_lock_fix_price_yn" class="info">
                        1개월 고정금액 {{ item.p_lock_fix_price | numberFormatFilter }}
                    </span>
                    <span v-else class="info">개월별 차등금액</span>
                </li>
                <li v-if="(data.items || []).length === 0" class="no-msg">
                    <span>등록된 락커가 없습니다.</span>
                </li>
            </ul>
        </div>

        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'SettingLocker',
    components: { LoadingSpinner },
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
    },
    data() {
        return {
            isLoading: false,
            data: {},
            pagingInfo: { ...pagingInfo },
        };
    },
    mounted() {
        this.pagingInfo.page = this.$route.query.page || 1;
        this.load();
    },
    methods: {
        load() {
            this.isLoading = true;
            api.get(`/admin/api/locker/group/${this.centerId}`, {
                params: this.pagingInfo,
            })
                .then((res) => {
                    this.isLoading = false;
                    this.setPageParams(res.data);
                    this.data = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.load();
        },
    },
};
</script>
<style lang="scss"></style>
